export default __webpack_public_path__ + "logo-with-text.bb11b0e690c977f2a0f5.svg";